﻿import {AccountSummaryController} from "./summary/accountSummary.controller";
import {BillSummaryController} from "./billing/billSummary.controller";
import {AccountSummaryGateway} from "./summary/accountSummary.gateway";
import {BillSummaryGateway} from "./billing/billSummary.gateway";

export default angular.module('idi.marketplace.account', ['core'])
    .controller("billSummary.controller", BillSummaryController)
    .controller("accountSummary.controller", AccountSummaryController)
    .service('accountSummary.gateway', AccountSummaryGateway)
    .service('billSummary.gateway', BillSummaryGateway)
    .config(routeConfig)
    .name;

routeConfig.$inject = ['$stateProvider'];

function routeConfig($stateProvider: ng.ui.IStateProvider): void {
    $stateProvider
        .state('shellFrame.accountFrame.accountSummary',
        {
            url: 'accountSummary/',
            templateUrl: 'modules/account/summary/accountSummary.view.html',
            controller: 'accountSummary.controller',
            controllerAs: 'vm',
            data: { claimsProfile: { allowAnonymousAccess: false } },
            resolve: {}

        })
        .state('shellFrame.accountFrame.billSummary',
        {
            url: 'billSummary/',
            templateUrl: 'modules/account/billing/billSummary.view.html',
            controller: 'billSummary.controller',
            controllerAs: 'vm',
            resolve: {}
        });
}